module.exports = __webpack_public_path__ + "static/media/rerecord-icon.fef0471c.svg";